const MENTION_REGEX = /@\[([^\]]+)\]\((\w+):([^)]+)\)/g

export function mentionContentToPlainText(content: string): string {
  return content.replace(new RegExp(MENTION_REGEX.source, 'g'), '@$1').replace(/\u00a0/g, ' ')
}
